import { render, staticRenderFns } from "./DeskNotice.vue?vue&type=template&id=6060e600&scoped=true&"
import script from "./DeskNotice.vue?vue&type=script&lang=js&"
export * from "./DeskNotice.vue?vue&type=script&lang=js&"
import style0 from "./DeskNotice.vue?vue&type=style&index=0&id=6060e600&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6060e600",
  null
  
)

export default component.exports